export default {
  allMitigationHabitats: (state) => state.mitigationHabitats
}
